<template>
  <span class="text-hide">
    <text-highlight :val="content" :highlight-key="highlightKey" :color="color"/>
    <span
        class="full-text"
        @click.stop="showAll = !showAll"
        v-show="valSize > maxSize"
        v-if="!hideBtn"
    >
      {{ showAll ? '收起' : '全文' }}
    </span>
  </span>
</template>

<script>

import TextHighlight from "@/components/text-highlight.vue";
import {getStringByMaxSize, getStringSize} from "@/common/util";

export default {
  name: 'text-hide',
  components: {TextHighlight},
  props: {
    val: {
      default: '',
    },
    maxSize: {
      default: 50,
    },
    hideBtn: {
      default: false,
    },
    highlightKey: {
      default: '',
    },
    color: {
      default: '#FF6700',
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    valSize() {
      return getStringSize(this.val);
    },
    content() {
      const maxSize = this.maxSize;
      let val = this.val;
      if (!this.showAll && this.valSize > maxSize && maxSize > 0) {
        val = getStringByMaxSize(val, maxSize) + '...';
      }
      return val;
    },
  }
}
</script>

<style scoped>
.full-text {
  color: #2A63F3;
}
</style>
